export default () => {
  if (useRuntimeConfig().public.googleTagManagerId) {
    const gtm = useScriptGoogleTagManager();
    return gtm?.proxy?.dataLayer;
  } else {
    return {
      push: (...args) => {
        console.log('[GTM] push', ...args);
      },
    };
  }
};
